import { Alert, TextButton } from '@zillow/constellation-10';
import { useAuth } from '../../AuthProvider';

type WrongAccountAlertProps = {
  textLabel: 'listing' | 'conversation';
};

function getSwitchAccountsHref() {
  if (typeof window === 'undefined') {
    return '/user/acct/login/';
  }
  return `/user/acct/login/?url=${encodeURIComponent(window.location.pathname + window.location.search)}`;
}

export default function WrongAccountAlert({ textLabel }: WrongAccountAlertProps) {
  const { user } = useAuth();
  const userEmail = user?.email;

  return (
    <Alert
      tone="warning"
      actionButton={
        <TextButton asChild>
          <a href={getSwitchAccountsHref()}>Switch accounts</a>
        </TextButton>
      }
    >
      {userEmail ? (
        <>
          You&rsquo;re signed in as <span className="fs-exclude">{userEmail}</span>. This email isn&rsquo;t connected to
          this {textLabel}. Sign in with the email address linked to your {textLabel}.
        </>
      ) : (
        <>
          This account isn&rsquo;t connected to this {textLabel}. Sign in with the email address linked to your{' '}
          {textLabel}.
        </>
      )}
    </Alert>
  );
}
